export default "__VITE_ASSET__jKormcvz__"